import styled from 'styled-components';
import { colors, zIndex } from '@ardoq/design-tokens';
import { ViewPaneElement } from 'atomicComponents/ViewPaneElement';

export const ViewPaneContainerElement = styled(ViewPaneElement)`
  @media print {
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
  }
  position: absolute;
  top: 0;
  left: 0;
  width: unset;
  flex: unset;
  background-color: ${colors.white950};
  z-index: ${zIndex.ABOVE_GRID_EDITOR_BACKGROUND};
  max-width: 100%;
`;
